import React, { FC, useMemo } from 'react';
import { ApprovalModalIsepStatusProps } from './ApprovalModalIsepStatusProps';
import { Stack } from '@mui/material';
import Text from '@ingka/text';
import useTranslation from '../../hooks/useTranslation';
import RadioButtonGroup from '@ingka/radio-button-group';
import { returnRadioButtons } from './utils';
import checkmark from '@ingka/ssr-icon/paths/checkmark-circle';
import SSRIcon from '@ingka/ssr-icon';
import { getFormattedDate } from '../ProjectListTable/utils';
import skapaColours from '@ingka/variables/colours-css';
import InlineMessage from '@ingka/inline-message';

const ApprovalModalIsepStatus: FC<ApprovalModalIsepStatusProps> = ({
  project,
  isep,
  setIsep,
  showDirectiveCaution,
}) => {
  const t = useTranslation();
  const list = useMemo(() => returnRadioButtons(t, isep, setIsep), [isep]);
  return (
    <Stack>
      <Text>
        <span style={{ fontWeight: 'bold' }}>
          {t('ppm.columns.isepApproval')}
        </span>
      </Text>
      <Text>
        <span style={{ fontWeight: 'normal' }}>
          {t('ppm.isep.description')}
        </span>
      </Text>
      {showDirectiveCaution && (
        <Stack pt={2} pb={2}>
          <InlineMessage
            body={t('ppm.isep.directiveCaution')}
            variant={'cautionary'}
            subtle={true}
          />
        </Stack>
      )}
      <RadioButtonGroup id={`isep-approval-radio`} list={list} />
      {project?.isep && (
        <Stack
          display={'flex'}
          flexDirection={'row'}
          alignItems={'center'}
          pt={3}
          gap={2}
        >
          <SSRIcon
            style={{ color: skapaColours.colourSemanticPositive }}
            paths={checkmark}
          />
          <Text>
            {t('ppm.isep.approved')} {getFormattedDate(project.isepDate)}
          </Text>
        </Stack>
      )}
    </Stack>
  );
};

export default ApprovalModalIsepStatus;
